import { api } from "../api";

export const getLeasedDogsByOwner = async (): Promise<any> => {
  const { data } = await api.get<object>(`/Lease/myleases`);

  return data;
};

export default { getLeasedDogsByOwner };
